import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.userName = ''
      this.phonenumber = ''
    }
  }
}
export default searchFrom
